import strings from './ar.json' with { type: 'json' };

/**
 * Every user-facing string lives in ar.json — none inline in a component.
 * A second language can then be added without touching UI code (CLAUDE.md).
 */
export type StringKey = keyof typeof strings;

type Values = Record<string, string | number>;

export function t(key: StringKey, values?: Values): string {
  const template = strings[key];
  if (!values) return template;
  return template.replace(/\{(\w+)\}/g, (whole, name: string) =>
    name in values ? String(values[name]) : whole,
  );
}

/** The document's language, used where the DOM needs it explicitly. */
export const LOCALE = 'ar';
